module.exports = __webpack_public_path__ + "img/loading_white.1d09a6c9.gif";